// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-5a4d73af] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.breadcrumb[data-v-5a4d73af] {
  width: 100%;
  flex-grow: 1;
  display: inline-flex;
  align-items: center;
}
.breadcrumb--collapsed[data-v-5a4d73af] .vue-crumb:last-child {
  min-width: 100px;
}
.breadcrumb nav[data-v-5a4d73af] {
  flex-shrink: 1;
  min-width: 0;
}
.breadcrumb .breadcrumb__crumbs[data-v-5a4d73af] {
  max-width: 100%;
}
.breadcrumb .breadcrumb__crumbs[data-v-5a4d73af], .breadcrumb .breadcrumb__actions[data-v-5a4d73af] {
  display: inline-flex;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/dialogs/node_modules/@nextcloud/vue/dist/assets/NcBreadcrumbs-B4eyDS9i.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-5a4d73af] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.breadcrumb[data-v-5a4d73af] {\n  width: 100%;\n  flex-grow: 1;\n  display: inline-flex;\n  align-items: center;\n}\n.breadcrumb--collapsed[data-v-5a4d73af] .vue-crumb:last-child {\n  min-width: 100px;\n}\n.breadcrumb nav[data-v-5a4d73af] {\n  flex-shrink: 1;\n  min-width: 0;\n}\n.breadcrumb .breadcrumb__crumbs[data-v-5a4d73af] {\n  max-width: 100%;\n}\n.breadcrumb .breadcrumb__crumbs[data-v-5a4d73af], .breadcrumb .breadcrumb__actions[data-v-5a4d73af] {\n  display: inline-flex;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
